import config from 'src/constants';
import { authHeader } from '../_helpers';
import axiosInstance from '../axios-orders';
import { Error, ErrorOutline } from '@material-ui/icons';
import {fetchWrapper} from '../_helpers/fetch-wrapper';
import axios from 'axios';
import moment from 'moment';
import data from 'src/views/customer/CustomerListView/data';

export const StatiticsService = {
    insertStatistics
};
  function insertStatistics(tramite) 
  {   
      console.log(tramite); 
      console.log(tramite[0]);  
      //let user = JSON.parse(localStorage.getItem('user'));
      var now = moment().format();
      let id = JSON.parse(localStorage.getItem('ocUserId'));      
       var formData = new FormData();       
       formData.append('files', tramite[0]);     
      
      formData.append('operation', new Blob([JSON.stringify({    
         
          "acceptanceRequirements": "ddddd",
          "id": 0,
          "limitDate":  tramite.date,
          "mintedLetter": "",
          "name": tramite.FirstName,
          "phone": tramite.phone,
          "position": tramite.position,
          "procedureDate": now,
          "requestedInformation":  tramite.information,
          "status": "REVIEW",
          "surname":  tramite.LastName,
          "type": "STATITIC",
          "userId": id
          

      })], {type: 'application/json'}));
   
     return axiosInstance().post('/api/statistic/',formData).then(data => 
      {
        // store user details and jwt token in local storage to keep user logged in between page refreshes      
        return data;        
     });

   
 }